module.exports = __webpack_public_path__ + "static/media/icon-edit.ea903e7e.svg";